/**
 * @generated SignedSource<<d3059837b0bdbf2e7717d14c4b3e2f7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileUploadAreaQuery$variables = Record<PropertyKey, never>;
export type FileUploadAreaQuery$data = {
  readonly store: {
    readonly filesQuota: {
      readonly quota: number;
      readonly used: number;
    };
    readonly id: string;
  };
};
export type FileUploadAreaQuery = {
  response: FileUploadAreaQuery$data;
  variables: FileUploadAreaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FilesQuota",
        "kind": "LinkedField",
        "name": "filesQuota",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quota",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "used",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadAreaQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FileUploadAreaQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "85ee12ad3df629f318dc6bef5e5dcc6e",
    "id": null,
    "metadata": {},
    "name": "FileUploadAreaQuery",
    "operationKind": "query",
    "text": "query FileUploadAreaQuery {\n  store {\n    id\n    filesQuota {\n      quota\n      used\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c2deb97cb67bb3b442d7e1f7301c624";

export default node;
